import { useMemo } from "react";
import Requests from "../../components/drawers/Requests";
import { useVisible } from "../../../../../utils/hooks/useVisible";

export const useRequestDrawer = ({ approve, deny }: any) => {
    const { visible, selected, open, close } = useVisible();

    const drawer = useMemo(() => {
        return (
            <Requests
                isOpen={visible}
                close={close}
                approve={approve}
                deny={deny}
                initialMenu={(selected as any)?.menu}
                focusedRequest={(selected as any)?.focusedRequest}
            />
        );
    }, [visible, selected, approve, deny, close]);

    return { open, drawer };
}
